import { render } from "./LastUpdatedSectionView.vue?vue&type=template&id=35a8934c&scoped=true"
import script from "./LastUpdatedSectionView.vue?vue&type=script&lang=js"
export * from "./LastUpdatedSectionView.vue?vue&type=script&lang=js"

import "./LastUpdatedSectionView.vue?vue&type=style&index=0&id=35a8934c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a8934c"]])

export default __exports__